module.exports = __webpack_public_path__ + "img/merge-csv-tool.8f2d74d1.png";